import React, { useState, useEffect } from "react";

import { Button, Slider, CircularProgress, Box } from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import ReactPlayer from "react-player";

export default function AltVideoCard(props) {
  let [altVideo, setAltVideo] = useState(props.altVideo);
  const [sliderValue, setSliderValue] = useState([
    Math.floor(altVideo.media_start_time),
    Math.floor(altVideo.media_end_time),
  ]);
  const [startTime, setStartTime] = useState(altVideo.media_start_time);
  const [endTime, setEndTime] = useState(altVideo.media_end_time);
  const [videoUrls, setVideoUrls] = useState([]);
  const [altSource, setAltSource] = useState(
    altVideo.video_s3_presigned_url +
      "#t=" +
      Math.floor(startTime) +
      "," +
      Math.floor(endTime)
  );
  const [duration, setDuration] = useState(100);

  const handleDuration = (duration) => {
    setDuration(duration);
  };
  const formatIntervalLabel = (value) => {
    return (
      Math.floor(value / 60) +
      ":" +
      (Math.floor(value % 60) < 10 ? "0" : "") +
      Math.floor(value % 60)
    );
  };

  const handleRangeSlider = (event, newValue) => {
    setSliderValue(newValue);
    let thisVideoID = altVideo.id || altVideo.video_story_clip_id;
    props.handleInterval(thisVideoID, sliderValue);
  };

  const handleResetInterval = () => {
    setSliderValue([
      Math.floor(altVideo.media_start_time),
      Math.floor(altVideo.media_end_time),
    ]);
    let thisVideoID = altVideo.id || altVideo.video_story_clip_id;
    props.handleInterval(thisVideoID, [
      Math.floor(altVideo.media_start_time),
      Math.floor(altVideo.media_end_time),
    ]);
  };
  
  const fetchSignedVideoUrls = async (segment) => {
      let newURL = "";
      // for (const segment of segments) {
        if (!segment.video_s3_bucket || !segment.video_s3_key) {
          newURL = "";
        } else {
          newURL = await fetchSignedVideoUrl(segment);
        }
      // }
      setVideoUrls(newURL +
        "#t=" +
        Math.floor(startTime) +
        "," +
        Math.floor(endTime));
    };
  
    const fetchSignedVideoUrl = async (segment) => {
      return await generateSignedUrlForVideo(
        segment.video_s3_bucket,
        segment.video_s3_key
      );
    };
  
    const generateSignedUrlForVideo = async (bucket, key) => {
      try {
        if (!bucket || !key) return null;
  
        const idToken = sessionStorage.getItem("idToken");
        if (!idToken) throw new Error("No ID Token found in sessionStorage");
  
        const s3Client = new S3Client({
          region: process.env.REACT_APP_AWS_REGION,
          credentials: fromCognitoIdentityPool({
            clientConfig: { region: process.env.REACT_APP_AWS_REGION },
            identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
            logins: {
              [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`]:
                idToken,
            },
          }),
        });
  
        const command = new GetObjectCommand({ Bucket: bucket, Key: key });
        return await getSignedUrl(s3Client, command, { expiresIn: 3600 });
      } catch (error) {
        console.error("Error generating signed URL for thumbnail:", error);
        return null;
      }
    };

  useEffect(() => {
    // console.log("updated slider value: ", sliderValue)
    setStartTime(sliderValue[0]);
    setEndTime(sliderValue[1]);
    setTimeout(() => {
      setAltSource(
        fetchSignedVideoUrls(altVideo)+"#t=" +
          sliderValue[0] +
          "," +
          sliderValue[1]
        // altVideo.video_s3_presigned_url 
      );
    }, 1500);
  }, [sliderValue]);

  return (
    <>
      <p className="alt-clip">
        <div className="alt-clip-metadata">
          <CalendarMonthIcon sx={{ verticalAlign: "middle", fontSize: 18 }} />{" "}
          {altVideo.first_pub_date}
          <TimerOutlinedIcon
            sx={{ verticalAlign: "middle", fontSize: 18, ml: 4 }}
          />{" "}
          {Math.floor((endTime - startTime) / 60)}:
          {Math.floor((endTime - startTime) % 60) < 10 ? "0" : ""}
          {Math.floor((endTime - startTime) % 60)} <br />
        </div>
        {altVideo.moment_summary}
      </p>
      {/* <p className='alt-clip2'> Length: {Math.floor(clip.duration / 60)}:{Math.floor(clip.duration % 60) < 10 ? '0' : ''}{Math.floor(clip.duration % 60)}</p> */}
      {/* <video
        key={altSource}
        style={{ borderRadius: 12, marginTop: 18 }}
        className="alt-clip"
        controls
      >
        <source src={altSource}></source>
      </video> */}
      {videoUrls.length>0 ? <>
        <ReactPlayer
          key={altSource || ""}
          url={videoUrls || ""}
          controls
          onDuration={handleDuration}
          width="100%" // Makes it responsive
          height="auto"
          style={{ borderRadius: 12, marginTop: 18 }}
          className="alt-clip"
        /> 
        <div style={{ display: "flex", paddingTop: 12 }}>
          <p className="alt-clip-interval-label">Customize Interval:</p>
          <Button
            onClick={handleResetInterval}
            variant="outlined"
            size="small"
            sx={{
              fontSize: 13,
              color: "#666666",
              borderColor: "#666666",
              borderRadius: 12,
              fontWeight: 400,
              float: "right",
              padding: 0,
              lineHeight: 0,
              verticalAlign: "middle",
              textTransform: "capitalize",
              fontFamily: "Roboto Condensed",
              "&:hover": {
                borderColor: "#666666",
                color: "#FFFFFF",
                background: "#666666",
              },
            }}
          >
            Reset
          </Button>
        </div>
        <Slider
          fullWidth
          valueLabelDisplay="on"
          key={props.altVideo.id}
          value={sliderValue}
          valueLabelFormat={(v) => formatIntervalLabel(v)}
          onChange={handleRangeSlider}
          // onChangeCommitted={handleRangeCommitted}
          min={0}
          max={duration}
          sx={{
            padding: 0,
            marginBottom: 2,
            marginTop: 1,
            "& .MuiSlider-thumb": {
              backgroundColor: "#ffffff",
              border: "4px solid #666666",
              height: 12,
              width: 12,
            },
            "& .MuiSlider-rail": {
              backgroundColor: "#cccccc",
            },
            "& .MuiSlider-track": {
              backgroundColor: "#666666",
              border: 0,
            },
            "& .MuiSlider-mark": {
              backgroundColor: "#AC1FFF",
              height: 8,
            },
            "& .MuiSlider-valueLabel": {
              backgroundColor: "#666666",
              borderRadius: 12,
              bottom: -54,
              paddingTop: "2px",
              paddingBottom: "2px",
              top: "auto",
              fontSize: 12,
              "&::before": {
                top: -7,
                bottom: "auto",
              },
            },
          }}
        />
      </>
      
      :<Box display="flex" justifyContent="center" alignItems="center" width="100%" marginTop={2}>
        <CircularProgress
          size={36}
          thickness={6}
          sx={{ color: "#AC1FFF" }}
        />
      </Box>}
      
    </>
  );
}
